module.exports = __webpack_public_path__ + "static/ogp-bb6b023738cee355de53bbfe76a71e7e.png";